<template>
<b-container
  class="d-flex section"
  :class="sectionColorClass"
  fluid
>
  <b-row class="m-auto text-center justify-content-center">
    <b-col class="p-0">     
      <b-container class="text-light text-center" fluid>
        <b-row>
          <b-col>
            <figure>
              <div class="px-5 pt-5">
                <b-img 
                  :src="require('../assets/' + image)" 
                  class="border"
                  fluid 
                />
              </div>
              <figcaption class="text-dark">
                {{ figCaption }}
              </figcaption>
            </figure>
            <b-button 
              size="lg" 
              class="my-5" 
              :class="btnClass"
              :href="'https://trinpod.us/pricing?industry=' + industry"
            >
              Get Started
            </b-button>
          </b-col>
        </b-row>
      </b-container>
    </b-col>
  </b-row>
</b-container>
</template>

<script>
export default {
  name: "ImageWithButtonSection",
  props: {
    sectionColorClass: String,
    image: String,
    figCaption: String,
    industry: String
  },
  computed: {
    btnClass() {
      if (this.industry === 'construction') {
        return 'btn-orange';
      } else if (this.industry === 'productivity') {
        return 'btn-neon-blue';
      }
    }
  }
}
</script>